export const specialties = [
  'Abdominal Surgery',
  'Addictionology',
  'Administrative Medicine',
  'Aerospace Medicine',
  'Allergy',
  'Ambulatory Care-outpatient clinic',
  'Anesthesia-pain management',
  'Anesthesiology',
  'Bariatrics',
  'Cardiac Surgery',
  'Cardiovascular - No Surgery',
  'Cardiovascular Disease-minor surgery',
  'Cardiovascular Diseases-no surgery',
  'Cardiovascular-Surgery',
  'Colon and/or Rectal surgery',
  'Dermatology-including minor surgery',
  'Dermatology-Major Surgery',
  'Dermatology-No Surgery',
  'Dermatology-No Surgery-GraftInject',
  'Dermatology-surgery including liposuct',
  'Dermatopathology-Minor Surgery',
  'Diabetes-including minor surgery',
  'Emergency Medicine Moonlighting-no surg',
  'Emergency Medicine Moonlight-minor surg',
  'Emergency Medicine-minor surgery',
  'Emergency Medicine-no major surgery',
  'Endocrinology, Reproductive',
  'Endocrinology-including minor surgery',
  'Endocrinology-surgery',
  'Forensic Medicine',
  'FP/GP - Limited Obstetrics-Surgery',
  'FP/GP - No Obstetrics',
  'FP/GP - Significant Obstetrics-Surgery',
  'FP/GP not primarily engaged in major sur',
  'FP/GP-minor surgery inc OB (but w/o C-sec)',
  'FP/GP-minor surgery-no OB',
  'FP/GP-minor surgery-no OB ',
  'FP/GP-no surgery ',
  'Gastroenterology-including minor surger',
  'Gastroenterology-no surgery',
  'Gastroenterology-surgery',
  'General Preventive Medicine-no surgery',
  'General Surgery (N.O.C.)',
  'Geriatrics-including minor surgery',
  'Geriatrics-surgery',
  'Gynecology-major surgery',
  'Gynecology-minor surgery',
  'Gynecology-no surgery',
  'Gynecology-surgery',
  'Hand and Foot Surgery',
  'Hand- surgery',
  'Head and Neck Surgery',
  'Hematology-including minor surgery',
  'Hematology-minor surgery',
  'Hematology-no surgery',
  'Hospitalist',
  'Infectious Diseases-including minor sur',
  'Intensive Care Medicine',
  'Internal Medicine-minor surgery',
  'Internal Medicine-no surgery',
  'Legal Medicine',
  'Medical Director Only-mgd care org',
  'Medical Director Only-non-managed care',
  'Neonatal/Perinatal Medicine',
  'Neonatology-minor surgery',
  'Neoplastic Disease/Oncology-inc minor s',
  'Neoplastic Diseases-surgery',
  'Nephrology-including minor surgery',
  'Nephrology-no surgery',
  'Nephrology-surgery',
  'Neurological Surgery ',
  'Neurological Surg-limited to back surg',
  'Neurology (inc. child)-including minor ',
  'Neurology-including minor surgery',
  'Neurology-no surgery ',
  'Nuclear Medicine',
  'OB/GYN Surgery',
  'Occupational Medicine',
  'Oncology-minor surgery ',
  'Oncology-no surgery ',
  'Ophthalmology-minor surgery ',
  'Ophthalmology-no surgery',
  'Ophthalmology-ocular plastic',
  'Ophthalmology-surgery',
  'Oral and Maxillofacial Surg and Anesth',
  'Oral and Maxillofacial Surgeon ',
  'Oral Pathologist',
  'Oral Radiologist',
  'Oral Surgery (MD or DDS)',
  'Orthopedic - Including Spinal Surgery',
  'Orthopedic - No Spinal',
  'Orthopedic Surgery',
  'Orthopedic Surgery-No Spinal Surgery',
  'Otorhinolaryngology-minor surgery',
  'Otorhinolaryngology-no surgery',
  'Otorhinolaryngology-surgery, cosmetic',
  'Otorhinolaryngology-surgery, non-cosmet',
  'Pain Management-no surgery ',
  'Pain Management-surgery ',
  'Pathology-including minor surgery',
  'Pathology-no surgery ',
  'Pediatric-including minor surgery',
  'Pediatric-minor surgery',
  'Pediatric-no surgery',
  'Peer Review Only',
  'Pharmacology-clinical',
  'Physical Medicine and Rehabilitation',
  'Physicians-N.O.C. surgery on own pat',
  'Plastic Surgery ',
  'Podiatry',
  'Podiatry, minor Surgery',
  'Podiatry, No Surgery',
  'Psychiatry',
  'Psychiatry (including child)',
  'Psychiatry inc shock therapy',
  'Public Health',
  'Pulmonary Diseases-no surgery',
  'Radiation-therapy',
  'Radiation-therapy-minor surgery',
  'Radiology-diagnostic-minor surgery',
  'Radiology-diagnostic-no surgery',
  'Radiology-major invasive',
  'Rheumatology-no surgery',
  'Thoracic Surgery',
  'Traumatic Surgery',
  'Urgent Care-non ER-no surgery',
  'Urology Surgery',
  'Urology-minor surgery',
  'Urology-no surgery',
  'Utilization Mgmt',
  'Vascular Surgery',
  'Volunteer',
  'Weight Reduction Surgery',
];
